import { useControlsCore } from "./useControlsCore";
import { useKeyboardControls } from "./useKeyboardControls";
import { useTouchControls } from "./useTouchControls";

const useControls = () => {
  const { onInputStart, onInputEnd } = useControlsCore();
  useKeyboardControls(onInputStart, onInputEnd);
  const touchHandlers = useTouchControls(onInputStart, onInputEnd);

  return { ...touchHandlers };
};

export default useControls;
